const root = global || window
import config from "../../../../config.js"


// 值类型判断 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
export const isUndefined = val => typeof val === 'undefined'

export const isNull = val => val === null

export const isFunction = val => typeof val === 'function'

export const isArray = val => val instanceof Array

const __error__type = [
  'Error',
  'EvalError',
  'RangeError',
  'ReferenceError',
  'SyntaxError',
  'TypeError',
  'URIError'
]
  .map(key => root[key])
  .filter(type => !isUndefined(type))
export const isError = val => __error__type.some(type => val instanceof type)

export const isObject = val =>
  typeof val === 'object' && !(isArray(val) || isNull(val))

export const isBoolean = val => typeof val === 'boolean'

export const isString = val => typeof val === 'string'

export const isExist = val => !(isUndefined(val) || isNull(val))

export const isNaN = val => val !== val

export const isNumber = val => typeof val === 'number' && !isNaN(val)
// 值类型判断 -------------------------------------------------------------

// 环境判断 +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
export const isAndroid = () => /(Android)/i.test(window.navigator.userAgent)

export const isAkulakuAndroid = () => {
  console.warn('此方法即将弃用，请使用 @common.akulaku.isAkulakuAndroid 代替')
  return isAndroid() && isExist(window[config.ANDROID_INTERFACE])
}

export const isIOS = () =>
  /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent)

export const isWKWebview = () => isIOS() && isExist(window.webkit)

export const isDesktop = () =>
  /(Win32|Win64|MacIntel|Linux x86_64)/i.test(window.navigator.platform)

export const isMobile = () => !isDesktop() && (isAndroid() || isIOS())

export const isAkulakuIOS = () => {
  console.warn('此方法即将弃用，请使用 @common.akulaku.isAkulakuIOS 代替')

  return (
    isWKWebview() &&
    isExist(window.webkit.messageHandlers) &&
    isExist(window.webkit.messageHandlers.changeLanguage)
  )
}

export const isAkulaku = () => {
  console.warn('此方法即将弃用，请使用 @common.akulaku.isAkulaku 代替')

  return isAkulakuIOS() || isAkulakuAndroid()
}
// 环境判断 -------------------------------------------------------------
